<template>
  <div>
    <NavBar v-bind:displayLogo="false" v-bind:displayUser="true"></NavBar>
    <Menu v-show="true"></Menu>
    <Information></Information>
    <Footer v-bind:nextStep="nextStep"></Footer>
  </div>  
</template>
<script>
  import NavBar from '@component-basic/NavBar.vue'
  import Menu from '@component-postulant/Menu.vue'
  import Footer from '@component-postulant/Footer.vue'
  import Information from '@component-postulant/Step01.vue'
  export default{
    components: {
      NavBar,
      Menu,
      Footer,
      Information
    },
    data() {
      return {
        nextStep: 'Datos Generales'
      };
    }
  }
</script>